import AppRecord from './AppRecord'
import APP from '../../../main'

class TradeSuggestion extends AppRecord {
  get deposit(){
    return this.constructor.employeeStore.deposits.find(dep => dep.id === this.deposit_id)
  }
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get account(){
    return this.constructor.employeeStore.accountsById.get(this.account_id)
  }
  get issue(){
    return this.constructor.employeeStore.issues.find(dep => dep.id === this.issue_id)
  }
  get creator(){
    return this.constructor.employeeStore.users.find(dep => dep.id === this.created_by)
  }
  get event(){
    return this.constructor.employeeStore.events.find(dep => dep.id === this.event_id)
  }
  set event(item){
    if(item){
      this.constructor.employeeStore.controllers.EventsController.changeDatum(item)
    }
  }
  get bankRulesActive(){
    if (this.account && this.account.transaction_rules.length > 0){
      return true
    }

    return false
  }
  get hasAllDates(){
    if (this.internal_mail_at && 
        this.client_mail_at &&
        this.client_acceptance_at && 
        this.booked_at &&
        this.booked_confirmed_at){
        return true
      }
      return false
    }
}

export default TradeSuggestion
